"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChunkParser = void 0;
class ChunkParser {
  constructor({
    parser
  }) {
    this.parser = parser;
  }
  parse(chunk) {
    const results = {
      data: [],
      errors: []
    };
    for (let index = 0; index < chunk.length; ++index) {
      const result = this.parser.parse(chunk[index]);
      if (result.errors != null) {
        results.errors.push({
          index,
          value: result.errors
        });
      } else {
        results.data.push({
          index,
          value: result.data
        });
      }
    }
    return results;
  }
}
exports.ChunkParser = ChunkParser;